import { render } from "./schedule-sunday.vue?vue&type=template&id=11765140"
import script from "./schedule-sunday.vue?vue&type=script&lang=js"
export * from "./schedule-sunday.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__